import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import Version from '../../assets/images/svg/version_history.svg';
import Line from '../../assets/images/svg/vertical_line.svg';
import cookieUtils from "../../utils/cookieUtils";
import { _axios } from '../../utils/axios';


const CustomScrollbarStyles = () => (
    <style>{`
      .custom-scrollbar::-webkit-scrollbar {
        width: 8px;
        background-color: #f1f1f1;
      }
      .custom-scrollbar::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #5C61F2;
        border-radius: 10px;
        border: 2px solid #f1f1f1;
        max-height: 10px !important;
      }
    `}</style>
);

const getStylesSection = () => `
    <style type="text/css">
        body {
            font-family: "Roboto", sans-serif;
        }
        .sec-title {
            font-size: 3rem;
            color: #525151;
            font-weight: 600;
            line-height: 1.3;
        }
        .small-title-dark {
            font-size: 16px !important;
            font-weight: 500;
            color: #525151 !important;
            font-family: "Roboto", sans-serif;
        }
        .para-text {
            font-size: 16px;
            color: #595959;
            font-weight: 400;
            line-height: 1.5;
            font-family: "Roboto", sans-serif;
        }
        .checkbox-container {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-radius: 8px;
            cursor: pointer;
            width: 100%;
            margin-bottom: 10%;
        }
        .checkbox-container input[type="checkbox"] {
            width: 20px;
            height: 20px;
            margin-right: 12px;
            cursor: pointer;
        }
        .checkbox-container label {
            font-size: 16px;
        }
        .title {
            color: #525151 !important;
            font-size: 16px;
            font-weight: 600;
            padding-bottom: 10%;
        }
    </style>
`;
const convertToDesiredHtml = (quillContent) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = quillContent;

    let formattedHtml = `
<!DOCTYPE html>
<html lang="en">
<head>
    <title>Privacy Policy</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet">
    ${getStylesSection()}
</head>
<body>
    <div class="container pt-4">`;

    // Directly use the Quill editor content while preserving structure
    Array.from(tempDiv.children).forEach(element => {
        if (element.tagName === 'H1') {
            formattedHtml += `<h1 class="sec-title pt-4">${element.innerHTML}</h1>`;
        } else if (element.tagName === 'H2') {
            formattedHtml += `<h2 class="small-title-dark pt-4">${element.innerHTML}</h2>`;
        } else if (element.tagName === 'UL') {
            formattedHtml += `<ul class="ps-5 pt-3 para-text" style="list-style: disc;">`;
            Array.from(element.children).forEach(li => {
                formattedHtml += `<li>${li.innerHTML}</li>`;
            });
            formattedHtml += `</ul>`;
        } else if (element.tagName === 'P') {
            formattedHtml += `<p class="para-text">${element.innerHTML}</p>`;
        }
    });

    formattedHtml += `
    </div>
</body>
</html>`;

    return formattedHtml;
};

const TermTable = ({ show, handleClose, initialShowHistory = false, language }) => {
    const [editorValue, setEditorValue] = useState('');
    const [termsData, setTermsData] = useState({});
    const [showVersionHistory, setShowVersionHistory] = useState(initialShowHistory);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentVersion, setCurrentVersion] = useState(1.00);
    const [versionHistory, setVersionHistory] = useState([]);
    const userRole = cookieUtils.getSecureCookie('role');
    const userEmail = cookieUtils.getSecureCookie('email');
    const userData = cookieUtils.getSecureCookie('user');
    const adminId = cookieUtils.getSecureCookie('admin_id');
    const userId = cookieUtils.getSecureCookie('user_id');

    console.log('Cookie Data:', {
        role: userRole,
        email: userEmail,
        userData,
        adminId,
        userId
    });
    const currentId = userRole === 'superadmin' ? adminId : userId;
    console.log('Using ID:', currentId);


    // Fetch terms and conditions data
   useEffect(() => {
    const fetchTermsData = async () => {
        if (!show) return;
        setIsLoading(true);
        
        try {
            const response = await _axios.get(`${ServerPath}/donation-term-conditions/latest`);
            const data = response?.data?.data || {};
            setTermsData(data);

            // 1. Identify which field to look for based on the language prop
            let rawHtml = '';
            switch (language) {
                case 'en': rawHtml = data.donation_term_details; break;
                case 'hi': rawHtml = data.donation_term_details_hin; break;
                case 'gu': rawHtml = data.donation_term_details_guj; break;
                case 'mr': rawHtml = data.donation_term_details_mar; break;
                default: rawHtml = data.donation_term_details;
            }

            // 2. Parse the HTML and extract the container content
            if (rawHtml) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = rawHtml;
                
                // Look for the specific container used in your convertToDesiredHtml function
                const contentDiv = tempDiv.querySelector('.container');
                setEditorValue(contentDiv ? contentDiv.innerHTML : rawHtml);
            } else {
                setEditorValue(''); // Reset if no data exists for this language
            }

            // 3. Set the version
            if (data.donation_term_version) {
                setCurrentVersion(parseFloat(data.donation_term_version));
            }

        } catch (err) {
            setError('Failed to load terms and conditions');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    fetchTermsData();
}, [show, language]);

    useEffect(() => {
        const fetchVersionHistory = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/donation-term-conditions/admin`);
                if (response.data?.success === 1 && response.data?.data) {
                    const versionData = response.data.data.map(item => {
                        const date = new Date(item.formatted_time);
                        date.setMinutes(date.getMinutes() + 330); // Add 5 hours and 30 minutes (330 minutes)
                        
                        return {
                            time: date.toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true
                            }),
                            admin: userData?.name || item.created_by || 'Unknown Admin'
                        };
                     });
                    setVersionHistory(versionData);
                }
            } catch (err) {
                console.error('Error fetching version history:', err);
            }
        };

        if (show && showVersionHistory) {
            fetchVersionHistory();
        }
    }, [show, showVersionHistory]);


    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image', 'video'],
            ['clean']
        ]
    };

    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video'
    ];


    const quillStyles = {
        '.ql-toolbar.ql-snow': {
            border: 'none',
            borderBottom: '1px solid #dee2e6',
            padding: '8px',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px'
        },
        '.ql-container.ql-snow': {
            border: 'none',
            minHeight: '350px',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px'
        }
    };


    // Handle update button click
    const handleUpdate = async () => {
        try {
            setIsLoading(true);
            const newVersion = (currentVersion + 0.01).toFixed(2);

            // Convert Quill content to formatted HTML
            const formattedHtml = convertToDesiredHtml(editorValue);

            const response = await _axios.put(`${ServerPath}/donation-term-conditions/update`, {
                donation_term_version: newVersion,
                donation_term_details: language === 'en' ? formattedHtml : (termsData.donation_term_details || ''),
                donation_term_details_hin: language === 'hi' ? formattedHtml :(termsData.donation_term_details_hin || ''), 
                donation_term_details_guj: language === 'gu' ? formattedHtml :(termsData.donation_term_details_guj || ''), 
                donation_term_details_mar: language === 'mr' ? formattedHtml :(termsData.donation_term_details_mar || ''),
                created_by: userData?.name || 'Unknown User',
                modified_by: userData?.name || 'Unknown User',
            });

            if (response.data.success) {
                setCurrentVersion(parseFloat(newVersion));
                handleClose();

                setTimeout(() => {
                    const toastDiv = document.createElement('div');
                    toastDiv.style.cssText = `
                        position: absolute;
                        top: 2px;
                        right: 20px;
                        background: white;
                        padding: 18px 20px;
                        border-radius: 4px;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                        z-index: 1050;
                        border-left: 4px solid #4CAF50;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.87);
                        min-width: 250px;
                        min-height: 30px;
                    `;
                    toastDiv.textContent = 'Changes updated successfully.';

                    const containerElement = document.querySelector('.container-fluid');
                    if (containerElement) {
                        containerElement.style.position = 'relative';
                        containerElement.appendChild(toastDiv);
                    }

                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }, 300);
            } else {
                setError('Failed to update terms and conditions');
            }
        } catch (err) {
            console.error('Error updating terms:', err);
            setError('Failed to update terms and conditions');
        } finally {
            setIsLoading(false);
        }
    };

    const getInitials = (name) => {
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            aria-labelledby="terms-modal"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
            <Modal.Header closeButton={showVersionHistory}>
                <Modal.Title className="d-flex justify-content-between align-items-center w-100">
                    Terms and Conditions management
                    {!showVersionHistory && (
                        <Button
                            variant="warning"
                            className="border-0 px-4 rounded-3 text-white"
                            onClick={() => setShowVersionHistory(true)}
                        >
                            Version History
                        </Button>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex" style={{ minHeight: '500px', backgroundColor: 'white', padding: '16px' }}>
                {/* Main Editor Section */}
                <div
                    className="flex-grow-1"
                    style={{
                        width: showVersionHistory ? '80%' : '100%',
                        transition: 'width 0.3s ease',
                        marginRight: '16px'
                    }}
                >
                    {isLoading ? (
                        <div className="text-center p-4">Loading...</div>
                    ) : error ? (
                        <div className="text-danger p-4">{error}</div>
                    ) : (
                        <div style={{ backgroundColor: 'white', height: '445px' }}>
                            <ReactQuill
                                value={editorValue}
                                onChange={setEditorValue}
                                modules={modules}
                                formats={formats}
                                style={{
                                    height: '400px',
                                    background: 'white',
                                    ...quillStyles
                                }}
                            />
                        </div>
                    )}
                </div>

                {/* Version History Sidebar */}
                {showVersionHistory && (
                    <div className="border rounded-2" style={{ width: '20%', backgroundColor: 'white', height: '445px' }}>
                        <CustomScrollbarStyles />
                        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                            <h6 className="m-0 fw-semibold">Version History</h6>
                            <Button
                                variant="close"
                                onClick={() => setShowVersionHistory(false)}
                            />
                        </div>
                        <div className="p-3 custom-scrollbar" style={{
                            overflowY: 'auto', height: 'calc(100% - 49px)',
                        }}>
                            {versionHistory.map((version, index) => (
                                <div key={index} className="d-flex align-items-start mb-4 position-relative">
                                    <div className="position-relative">
                                        <div className="me-3 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', backgroundColor: '#E2E8F0' }}>
                                            <img src={Version} alt="Version Icon" style={{ width: '20px', height: '20px' }} />
                                        </div>
                                        {index !== versionHistory.length - 1 && (
                                            <img
                                                src={Line}
                                                alt="Vertical Line"
                                                className="position-absolute"
                                                style={{
                                                    left: '15px',
                                                    top: '32px',
                                                    height: '50px',

                                                }}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <p className="m-0 text-primary fw-medium">{version.time}</p>
                                        <div className="d-flex align-items-center mt-2">
                                            <div
                                                className="d-flex align-items-center justify-content-center me-2 rounded-circle"
                                                style={{
                                                    width: '24px',
                                                    height: '24px',
                                                    backgroundColor: '#545252',
                                                    color: 'white'
                                                }}
                                            >
                                                {getInitials(version.admin)}
                                            </div>
                                            <span className="text-secondary small">{version.admin}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    style={{
                        backgroundColor: '#6366F1',
                        border: 'none',
                        padding: '8px 32px'
                    }}
                    onClick={handleUpdate}
                    disabled={isLoading}
                >
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );


};

export default TermTable;